import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import './Services.css';

const Services = props =>
  <div className="services">
    <Row>
      <Col>
        <h1>{props.heading}</h1>
        <hr></hr>
      </Col>
    </Row>
    <Row>
      {props.children}
    </Row>
  </div>
export default Services;

export const Service = props =>
  <Col md={`${props.md!==undefined?props.md:4}`}>
    <span className="fa-stack fa-5x">
      <i className="fa fa-circle fa-stack-2x text-primary"></i>
      <i className={`fa ${props.icon} fa-5 fa-stack-1x fa-inverse`}></i>
    </span>
    <h4 className="service-heading">{props.heading}</h4>
    <p className="text-muted">{props.description}</p>
  </Col>;


// WEBPACK FOOTER //
// ./src/common/Services.js